// extracted by mini-css-extract-plugin
export var background = "blogCategories-module--background--a3cd4";
export var block = "blogCategories-module--block--6ec94";
export var blockHeading = "blogCategories-module--block-heading--6d2db";
export var blockHealth = "blogCategories-module--block-health--9ae02";
export var blockOverlay = "blogCategories-module--block-overlay--1a426";
export var blockRecipes = "blogCategories-module--block-recipes--037af";
export var blockTravel = "blogCategories-module--block-travel--bccf8";
export var blocks = "blogCategories-module--blocks--47418";
export var container = "blogCategories-module--container--dfe80";
export var heading = "blogCategories-module--heading--64dd7";
export var icon = "blogCategories-module--icon--9c8e2";
export var subheading = "blogCategories-module--subheading--3e420";